export default "/images/mobile-menu.png?b1d5d37077eb3b2493252a851ce3a582";